<!-- 由 suu 创建于 2022-01-18 星期二 -->
<!-- 评估问卷-->
<template>
  <div class="recipe-question">
    <!-- 开始 -->
    <template v-if="star">
      <img class="st-bg-image" :src="starBgImage"></img>
      <div class="st-btn" @click="star = false">开始填写</div>
    </template>
    <!-- 问卷 -->
    <template v-else-if="questionData.length">
      <div class="">
        <view class="title">营养评估方案个人评估问卷</view>
        <v-steps class="steps-component" :current="current" :total="total" @prestep="preStep"></v-steps>
      </div>
    </template>
  </div>
</template>

<script>
import VSteps from './ponents/ques-steps.vue'
export default {
  name: 'recipe-question',

  components: { VSteps },

  props: {},

  data() {
    return {
      star: true,
      starBgImage:
        'https://cdnvue.gymcity.com.cn/uploads/b44378241da5f5e4505ef4347749b30c.png',
      topNum: 0, //scrollview内容距离顶部的距离
      id: this.$route.query.id, //营养评估方案id
      showSubmit: false, //显示提交弹框
      finish: false, //是否完成问卷
      current: 0, //过滤掉非必填项之后，当前是第几个问题
      stepList: ['基础数据', '生活习惯', '身体状态'],
      showClass: true, //是否显示大类
      showQuestion: false, //是否显示问题
      classIndex: 0, //目前处于第几大类
      curQuetionIndex: 0, //当前问题序号
      questionData: [], //问卷所有题目
      selectData: [], //当前问题的所有选项数据
      disabledStep: false //是否禁用下一步
    }
  },

  computed: {
    //去掉非必填项的总题目
    total() {}
  },

  watch: {},

  created() {
    this.getQuestionList()
  },

  mounted() {},

  destroyed() {},

  methods: {
    getQuestionList() {
      this.$toast.loading('加载中...')
      this.$http
        .postApp('member/AppCamp/posterQuestionNew', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.questionData = this.dealData(res.data)
          } else {
            this.$toast(res.msg)
          }
          this.$toast.clear()
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    dealData(data) {
      let filter = ['phase', 'nutritional_goal_lose_weight']
      data.map((item) => {
        item.sub_list.map((item1) => {
          if (filter.indexOf(item1.field) >= 0) {
            item1.hide = true
            item1.notQuestion = true
          }
        })
      })
      return data
    },
    // 上一步
    preStep() {}
  }
}
</script>

<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.recipe-question {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  .st-bg-image {
    width: 100%;
  }
  .st-btn {
    text-align: center;
    line-height: vw(88);
    position: absolute;
    bottom: vw(174);
    width: vw(634);
    height: vw(88);
    left: 50%;
    background-color: #fff;
    border-radius: vw(44);
    transform: translate(-50%, 0%);
    font-size: vw(30);
    color: #202025;
    font-weight: 600;
  }
}
</style>